import SkeletonLoader from "./skeleton-loader";

export default function NextStepsSkeleton() {
  return (
    <div className="next-steps skeleton">
      <SkeletonLoader className="border--rounded-lg bg--loader-bg-dark-secondary" width="100%" height={80} />
    </div>
  );
}
